import React from "react";
import { useLanguage } from "@/App";
import { motion } from "framer-motion";

const ClientLogos = () => {
  const { language } = useLanguage();

  const clients = [
    { name: "TechStart BV", industry: "SaaS" },
    { name: "GrowthLabs", industry: "Marketing" },
    { name: "Boutique Ella", industry: "E-commerce" },
    { name: "FinanceHub", industry: "Fintech" },
    { name: "CreativeStudio", industry: "Design" },
    { name: "MediCare Plus", industry: "Healthcare" },
    { name: "AutoFlow NL", industry: "Automotive" },
    { name: "FoodieBox", industry: "Food & Beverage" },
    { name: "SportZone", industry: "Fitness" },
    { name: "EduTech NL", industry: "Education" },
    { name: "GreenEnergy BV", industry: "Energy" },
    { name: "LegalEase", industry: "Legal" }
  ];

  const doubled = [...clients, ...clients];

  return (
    <section
      data-testid="client-logos-section"
      className="py-16 bg-[#0A0A0A] border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-8">
        <p className="text-center text-zinc-500 text-sm font-bold uppercase tracking-[0.2em]">
          {language === "nl" ? "Vertrouwd door 150+ bedrijven in Nederland" : "Trusted by 150+ companies in the Netherlands"}
        </p>
      </div>

      {/* Scrolling logos */}
      <div className="relative">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0A0A0A] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0A0A0A] to-transparent z-10" />

        <motion.div
          animate={{ x: ["0%", "-50%"] }}
          transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
          className="flex gap-12 items-center whitespace-nowrap"
        >
          {doubled.map((client, index) => (
            <div
              key={index}
              data-testid={`client-logo-${index}`}
              className="flex-shrink-0 flex items-center gap-3 px-6 py-3 bg-white/[0.02] border border-white/5 hover:border-[#FF6B00]/20 transition-colors"
            >
              <div className="w-10 h-10 bg-gradient-to-br from-[#FF6B00]/20 to-white/5 rounded-lg flex items-center justify-center">
                <span className="text-[#FF6B00] font-black text-sm">
                  {client.name.split(" ")[0].substring(0, 2).toUpperCase()}
                </span>
              </div>
              <div>
                <p className="text-white font-bold text-sm">{client.name}</p>
                <p className="text-zinc-600 text-xs">{client.industry}</p>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ClientLogos;
